import { isEmpty } from '@ember/utils';

export const responseActivityDetailValidations = [
  {
    message: 'Must not exceed 100 characters',
    validate: (val) => isEmpty(val) || `${val}`.length <= 100,
  },
  {
    message: 'Must not include commas',
    validate: (val) => isEmpty(val) || !`${val}`.includes(','),
  },
  {
    message: '',
    validate: (val) =>
      isEmpty(val) || /^[\p{L}\p{N}\s\-/'.():;!?&]*$/u.test(val),
  },
];

export function getResponseActivityDetailErrors(val) {
  return responseActivityDetailValidations
    .filter((v) => !v.validate(val))
    .map((v) => v.message);
}
